export enum WhoRewardedRewardTypes {
  OLD_REWARD = "OLD_REWARD",
  NEW_REWARD = "NEW_REWARD",
  CUSTOM_OLD_REWARD = "CUSTOM_OLD_REWARD",
  CUSTOM_NEW_REWARD = "CUSTOM_NEW_REWARD",
  CREDIT_REWARD = "CREDIT_REWARD",
  NO_REWARD = "NO_REWARD"
}

export enum WhoRewardedVisibilityTypes {
  FULL = "FULL",
  LIMITED = "LIMITED",
  HIDDEN = "HIDDEN"
}

export enum WhoRewardedTypes {
  SENDER = "SENDER",
  RECEIVER = "RECEIVER",
  VIEWER = "VIEWER",
  NO_USER = "NO_USER"
}
